import {
	vcpodeHttp as http,
} from "@/http";

import { serialize } from "./utils";

// Authenticated endpoints
const get = async (data = {}) => {
    const params = serialize({ ...data });
    return http.get(`bff/indication/admin/users${params}`);
}

const details = async (userId) => http.get(`bff/indication/admin/code/${userId}`)

const confirmPayment = async (data) => http.post(`bff/indication/admin/payment/confirm`, data);

const uploadURL = async (data) => http.post(`bff/indication/admin/payment/upload-url`, data);

const checkFile = async (receiptKey) => http.get(`bff/indication/admin/payment/check-file?receiptKey=${receiptKey}`);

// Public endpoints

export const indications = {
    get,
    details,
    confirmPayment,
    uploadURL,
    checkFile,
};
